import React, { Suspense } from 'react';

const EntityDetails = React.lazy(() => import('./entityDetails'));

const EntityDetailsPage = (props) => (
  <div>
    <Suspense fallback={<div className="px-4 py-6">Loading...</div>}>
      <EntityDetails {...props} />
    </Suspense>
  </div>
);

export default EntityDetailsPage;
